
const removeItem = function (key) {
    localStorage.removeItem(key);
}

const setExpiredItem = function (key, value) {
    let item = {
        'value': value,
        'expiration': new Date()
    };

    localStorage.setItem(key, JSON.stringify(item));
}

const setItem = function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
const getItem = function (key) {
    return JSON.parse(localStorage.getItem(key));
}

const renew = function (key) {
    let item = getItem(key);
    if (item.expiration) {
        item.expiration = new Date();

        localStorage.setItem(key, JSON.stringify(item));
    }
}

const checkExpiration = function (key, expiration) {
    let item = getItem(key);
    if (item.expiration) {
        let itemexpiration = new Date(item.expiration);

        let lifetime = expiration;

        if ((new Date() - itemexpiration) < lifetime) {
            return item;
        } else {
            return null;
        }
    }
    return null;
}

const checkIfExists = function (key) {
    return (localStorage.getItem(key) !== null);
}

export { removeItem, setExpiredItem, setItem, getItem, renew, checkExpiration, checkIfExists }